/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage (data){
            return http.json({
                url: `/order/deliverRecord/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        getInfo (data){
            return http.json({
                url: `/order/deliverRecord/get?id=${data.id}`,
                data
            })
        },
        getByOrgId(data){
            return http.json({
                url: `/order/deliverRecord/getByOrgId?id=${data.id}`,
                data
            })
        },
        batchByOrgIds (data){
            return http.json({
                url: `/order/deliverRecord/batchGetByOrgIds`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/order/deliverRecord/save`,
                data
            })
        },

        queryAll (data){
            return http.json({
                url: `/order/deliverRecord/queryByParams`,
                data
            })
        },

        queryTelByParams (data){
            return http.json({
                url: `/order/deliverRecord/queryTelByParams`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/order/deliverRecord/delete`,
                data
            })
        },

        batchSave (data){
            return http.json({
                url: `/order/deliverRecord/batchSave`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/deliverGoodsRecord.js